export default {
    data: [],
    uploadInProgress: false,
    uploadProgress: 0
}